import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddStaffLayer from "../components/AddStaffLayer";

const AddStaffPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Staff' />

        {/* BlogLayer */}
        <AddStaffLayer />
      </MasterLayout>
    </>
  );
};

export default AddStaffPage;
